export default "__VITE_ASSET__Btyt0YZX__"